@if (landingPageSplitBlock()) {
    <header
        class="bg-primary/20 mb-8 flex h-auto flex-col items-center gap-6 px-4 py-8 md:mb-10 md:px-20 lg:mb-12 lg:h-96 lg:flex-row lg:gap-12 lg:px-40 lg:py-0 xl:px-52"
    >
        <div class="lg:flex-1">
            <p class="xl:text-headline-medium lg:text-headline-small text-title-small text-left lg:text-right">
                {{ landingPageSplitBlock().translations_refs | getTranslation: "left_text" }}
            </p>
        </div>
        <span class="bg-neutral-variant-40/20 h-px w-full lg:h-50 lg:w-px"></span>
        <div class="lg:flex-1">
            <p class="lg:text-title-small text-body-small pb-6">
                {{ landingPageSplitBlock().translations_refs | getTranslation: "right_text" }}
            </p>
            <a
                class="border-primary hover:bg-primary-98 text-body-small text-primary cursor-pointer rounded-md border bg-white px-4 py-2 text-center transition-colors"
                [href]="learnMorePage() | pathFromItem: 'page'"
            >
                {{ "home.learn_more" | transloco }}
            </a>
        </div>
    </header>
}
